import { useEffect, useState } from 'react';
import { GridColDef, GridPaginationModel } from '@mui/x-data-grid';
import { Chip } from '@mui/material';

import { RedirectParams } from '../../../../../shared/types/redirectParams';
import { asyncGetParamsClassName } from '../../../../../services/param.service';
import { ISelect, ParamEnum } from '../../../../../shared/types/shared';
import { RedirectPqrListActions } from './actions';
import { TableTooltip } from '../../../../components/general/table';
import { isTrainerOrQuality } from '../../../../../shared/types/profiles';
import { RootState } from '../../../../../redux/store';
import { useSelector } from 'react-redux';

export const useRedirectPqrList = (filters?: RedirectParams) => {
    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState<RedirectParams[]>([]);
    const [page, setPage] = useState<number>(0);
    const [pageSize, setPageSize] = useState<number>(10);
    const [total, setTotal] = useState<number>(0);
    const [finalFilters, setFinalFilters] = useState<RedirectParams | object>(
        {}
    );
    const [actionsRefresh, setActionsRefresh] = useState(0);

    const paginator = (model: GridPaginationModel) => {
        if (model.page !== page) {
            setPage(model.page);
        } else if (model.pageSize !== pageSize) {
            setPageSize(model.pageSize);
        }
    };

    const columns: GridColDef<RedirectParams>[] = [
        {
            field: 'name',
            headerName: 'Nombre',
            minWidth: 120,
            flex: 0.5,
        },
        {
            field: 'extra',
            headerName: 'Correos',
            minWidth: 120,
            flex: 0.5,
        },
        {
            field: 'parent',
            headerName: 'Nombre Padre',
            minWidth: 120,
            flex: 0.5,
            renderCell: (row) => (
                <TableTooltip value={(row.row.parent as ISelect)?.name || ''} />
            ),
        },
        {
            field: 'status',
            headerName: 'Estado',
            minWidth: 100,
            flex: 0.5,
            align: 'center',
            headerAlign: 'center',
            sortable: false,
            disableColumnMenu: true,
            filterable: false,
            renderCell: (row: any) => {
                if (row.row.active === true) {
                    return (
                        <Chip
                            label="ACTIVO"
                            sx={{ ml: 1, fontSize: 11.5 }}
                            color="success"
                        />
                    );
                } else {
                    return (
                        <Chip
                            label="INACTIVO"
                            sx={{ ml: 1, fontSize: 11.5 }}
                            color="error"
                        />
                    );
                }
            },
        },
    ];

    if (!isTrainerOrQuality(type)) {
        columns.push({
            field: 'actions',
            headerName: 'Acciones',
            width: 100,
            sortable: false,
            disableColumnMenu: true,
            filterable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (row) => (
                <div className="no-click-cell">
                    <RedirectPqrListActions
                        id={row.id}
                        active={row.row.active ?? false}
                        onActionComplete={() =>
                            setActionsRefresh((prev) => prev + 1)
                        }
                    />
                </div>
            ),
        });
    }

    useEffect(() => {
        setPage(0);
        setFinalFilters(filters || {});
    }, [filters]);

    useEffect(() => {
        setLoading(true);
        let name: string | undefined;
        let extra: string | undefined;

        if (finalFilters && 'name' in finalFilters && 'extra' in finalFilters) {
            ({ name, extra } = finalFilters);
        }

        asyncGetParamsClassName(
            ParamEnum.PQR_REDIRECTION_PERSON,
            name,
            extra,
            page,
            pageSize
        )
            .then((res: any) => {
                setRows(res?.items);
                setTotal(res?.length);
            })
            .finally(() => setLoading(false));
    }, [page, pageSize, finalFilters, actionsRefresh]);

    return {
        columns,
        rows,
        page,
        pageSize,
        paginator,
        loading,
        total,
    };
};
